module.exports = __webpack_public_path__ + "static/004_body-landscape-60464e424c39d2d7f2deaa2f878ac375.mp4";